import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GLOBALSETTINGS } from '../data/constants';

interface dragRowState {
    draggedFolderId: number | null;
    parentFolderId: number | null;
}

const initialState: dragRowState = {
    draggedFolderId:GLOBALSETTINGS.DEFAULT_STATE,
    parentFolderId: GLOBALSETTINGS.DEFAULT_STATE
};

const dragRowSlice = createSlice({
    name: 'dragRow',
    initialState,
    reducers: {
         setDragRowFolder: (state, action: PayloadAction<{draggedFolderId : number |null ,parentFolderId: number | null}>) => {
            state.draggedFolderId = action.payload.draggedFolderId;
            state.parentFolderId = action.payload.parentFolderId;
        },        
        clearDragRowFolder:(state)=>{
            state.draggedFolderId = GLOBALSETTINGS.DEFAULT_STATE;
            state.parentFolderId = GLOBALSETTINGS.DEFAULT_STATE;
        }
    },
});

export const { setDragRowFolder, clearDragRowFolder} = dragRowSlice.actions;

export default dragRowSlice.reducer;
